import React from "react";

import {
  FaBuilding,
  FaIdBadge,
  FaLayerGroup,
  FaMapMarkerAlt,
} from "react-icons/fa";

import {
  SectionHeader,
  StatCard,
} from "../ui/DashboardUI";

import { nf } from "../utils/dashboard.utils";

export default function StructureStatsSection({
  stats,
  loading,
}) {
  return (
    <section className="mb-6">
      <SectionHeader
        title="Clubs & adhérents"
        subtitle="Structure globale dans l’application."
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          label="Clubs"
          value={nf.format(stats?.clubs || 0)}
          icon={FaBuilding}
          tone="indigo"
          loading={loading}
          sub="Total clubs"
        />

        <StatCard
          label="Dojos"
          value={nf.format(stats?.dojos || 0)}
          icon={FaMapMarkerAlt}
          tone="emerald"
          loading={loading}
          sub="Lieux d’entraînement"
        />

        <StatCard
          label="Groupes"
          value={nf.format(stats?.groups || 0)}
          icon={FaLayerGroup}
          tone="amber"
          loading={loading}
          sub="Groupes / créneaux"
        />

        <StatCard
          label="Adhérents"
          value={nf.format(stats?.adherents || 0)}
          icon={FaIdBadge}
          tone="rose"
          loading={loading}
          sub="Total adhérents"
        />
      </div>
    </section>
  );
}